import fetchBlogLinks from 'app/utilities/category-constants';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

function ReadMoreOnCategories(props) {
  const { selectedCategoryId } = props;
  const blogLinks = fetchBlogLinks(selectedCategoryId);

  return (
    <div>
      {blogLinks
        && (
        <Container
          className="bg-light pt-6"
        >
          <Row>
            <Col
              xs={24}
              className="bg-light text-gray-light pt-6 text-center"
            >
              <h2>Read More</h2>
            </Col>
          </Row>

          <Row>
            <Col
              xs={24}
              className="bg-light text-gray-light pt-3 text-center d-flex flex-wrap justify-content-center"
            >
              {blogLinks.map((item) => (
                <div className="blogLinks" key={item.id}>
                  <a href={item.url} target="_blank" rel="noopener noreferrer">{item.linkName}</a>
                </div>
              ))}
            </Col>
          </Row>
        </Container>
        )}
    </div>
  );
}

ReadMoreOnCategories.propTypes = {
  selectedCategoryId: PropTypes.string.isRequired,
};

export default ReadMoreOnCategories;
